// **  Package.json **
// Requirements
// - vee-validate ^2.2.7

//  Example Usage:
//
//  import validateVAT from '../../validations/vat';
//  ...
//  created() {
//      this.$validator.extend('validvat', validateVAT);
//  }

module.exports = {
  getMessage: () => 'NIF inválido.',
  validate: (value) => {
    var temErro = 0
    var comparador = null

    if (
      value.substr(0, 1) !== '1' && // pessoa singular
            value.substr(0, 1) !== '2' && // pessoa singular
            value.substr(0, 1) !== '3' && // pessoa singular
            value.substr(0, 2) !== '45' && // pessoa singular não residente
            value.substr(0, 1) !== '5' && // pessoa colectiva
            value.substr(0, 1) !== '6' && // administração pública
            value.substr(0, 2) !== '70' && // herança indivisa
            value.substr(0, 2) !== '71' && // pessoa colectiva não residente
            value.substr(0, 2) !== '72' && // fundos de investimento
            value.substr(0, 2) !== '77' && // atribuição oficiosa
            value.substr(0, 2) !== '79' && // regime excepcional
            value.substr(0, 1) !== '8' && // empresário em nome individual (extinto)
            value.substr(0, 2) !== '90' && // condominios e sociedades irregulares
            value.substr(0, 2) !== '91' && // condominios e sociedades irregulares
            value.substr(0, 2) !== '98' && // não residentes
            value.substr(0, 2) !== '99' // sociedades civis
    ) {
      temErro = 1
    }

    var check1 = value.substr(0, 1) * 9
    var check2 = value.substr(1, 1) * 8
    var check3 = value.substr(2, 1) * 7
    var check4 = value.substr(3, 1) * 6
    var check5 = value.substr(4, 1) * 5
    var check6 = value.substr(5, 1) * 4
    var check7 = value.substr(6, 1) * 3
    var check8 = value.substr(7, 1) * 2

    var total = check1 + check2 + check3 + check4 + check5 + check6 + check7 + check8
    var divisao = total / 11
    var modulo11 = total - parseInt(divisao) * 11

    if (modulo11 === 1 || modulo11 === 0) {
      comparador = 0
    } else {
      comparador = 11 - modulo11
    }

    var ultimoDigito = value.substr(8, 1) * 1
    if (ultimoDigito !== comparador) {
      temErro = 1
    }

    return temErro === 0
  }
}
